module.exports = __webpack_public_path__ + "static/media/Entrance-C-50.3103d925.webp";